<template>
  <b-row>
    <b-col>
      <img src="images/banner_support.jpg">
      <div @click="gotosupport()" class="m1"></div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "COntactUs",
  props: { },
  methods: {
    gotosupport() {
        this.$router.push('Support')
    },
  },
};
</script>

<style scoped>
div.contact {
  background-color: #9a240d !important;
  color: white;
}
.dot {
  height: 25px;
  width: 25px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
}
div.m1 {
  position: absolute;
  width: 30%;
  height: 55px;
  top: 48%;
  left: 35%;
  cursor: pointer;
}
</style>